const safeNumber = (value) =>
  Number(value || 0);

/* =====================================================
   CALCULATE HOTEL TOTALS
===================================================== */

const calculateHotelTotals = (
  hotel = {}
) => {

  /* =====================================================
     BASIC INPUTS
  ===================================================== */

  const nights = Math.max(
    1,
    safeNumber(hotel.nights)
  );

  const rooms = Math.max(
    1,
    safeNumber(hotel.rooms || 1)
  );

  const basePrice =
    safeNumber(
      hotel.basePrice
    );

  const extraAdultPrice =
    safeNumber(
      hotel.extraAdultPrice
    );

  const cwbPrice =
    safeNumber(
      hotel.cwbPrice
    );

  const cnbPrice =
    safeNumber(
      hotel.cnbPrice
    );

  /* =====================================================
     OCCUPANCY
  ===================================================== */

  const extraAdults =
    safeNumber(

      hotel.occupancy
        ?.extraAdults ??

      hotel.occupancy
        ?.extraAdult ??

      0
    );

  const cwbCount =
    safeNumber(

      hotel.occupancy
        ?.cwb ??

      hotel.occupancy
        ?.childWithBed ??

      0
    );

  const cnbCount =
    safeNumber(

      hotel.occupancy
        ?.cnb ??

      hotel.occupancy
        ?.childNoBed ??

      0
    );

  /* =====================================================
     NIGHT COST
  ===================================================== */

  const roomCost =
    basePrice * rooms;

  const extraAdultCost =
    extraAdultPrice *
    extraAdults;

  const cwbCost =
    cwbPrice *
    cwbCount;

  const cnbCost =
    cnbPrice *
    cnbCount;

  const nightlyTotal =
    roomCost +
    extraAdultCost +
    cwbCost +
    cnbCost;

  /* =====================================================
     NET HOTEL TOTAL
  ===================================================== */

  const subtotal =
    nightlyTotal *
    nights;

  /* =====================================================
     MANUAL OVERRIDE
  ===================================================== */

  const manualTotal =
    safeNumber(
      hotel.manualTotal
    );

  const finalTotal =
    manualTotal > 0
      ? manualTotal
      : subtotal;

  /* =====================================================
     RETURN STRUCTURE
  ===================================================== */

  return {

    nights,

    rooms,

    roomCost,

    extraAdultCost,

    cwbCost,

    cnbCost,

    nightlyTotal,

    subtotal,

    manualTotal,

    finalTotal:
      Math.round(
        finalTotal
      ),
  };
};

export default
  calculateHotelTotals;
